import { AlertCircleIcon } from "lucide-react"
import { Alert, AlertDescription, AlertTitle } from "@f2e/ui/components/base"

interface CopilotAlertProps {
  title: string
  description: string
}

const CopilotAlert = ({ title, description }: CopilotAlertProps) => {
  return (
    <Alert variant="destructive">
      <AlertCircleIcon />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>
        <p>{description}</p>
      </AlertDescription>
    </Alert>
  )
}

export { CopilotAlert }
export default CopilotAlert
